"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _components = require("../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Template = props => {
  const computeTitle = func => {
    let str;
    if (typeof func === "function") {
      try {
        str = func(props) || "Failed…";
      } catch (e) {
        str = "Loading…";
      }
    } else if (typeof func === "string") {
      str = func;
    }
    return str;
  };
  const {
    children,
    title,
    singular,
    link,
    editable,
    ...rest
  } = props;
  let nameLoaded = true;
  if (props.user) {
    if (props.user.data) {
      if (singular && props.user.data.Id !== singular) {
        nameLoaded = false;
      }
    }
  }
  let editPermission;
  let developerPermission;
  if (props.location !== undefined) {
    const pathName = props.location.pathname.split("/");
    const entityName = pathName[1];
    editPermission = props.auth.me.data.FlatPermissions.filter(permission => permission.Value === `control.${entityName}/edit`);
    developerPermission = props.auth.me.data.FlatPermissions.filter(permission => permission.Value === `*`);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexFlow: "column",
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid justify-content-center mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex mb-4 align-items-center"
  }, nameLoaded ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "page-title ml-0 mr-5"
  }, computeTitle(title)) : /*#__PURE__*/_react.default.createElement("h2", {
    className: "page-title ml-0 mr-5"
  }), editable && link && link.to && nameLoaded && (editPermission.length > 0 || developerPermission.length > 0) && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: computeTitle(link.to)
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-secondary mb-1"
  }, link.text))), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-inline-flex justify-content-start card card-wide rounded shadow mb-3 p-5"
  }, _react.default.Children.map(children, child => {
    return _react.default.cloneElement(child, {
      ...rest
    });
  }))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
};
var _default = exports.default = Template;
module.exports = exports.default;